import { motion } from "framer-motion";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
const ClaimProviderDiagnosis = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);

  const preauthDiagnosis = viewClaimInfo?.provider_request?.diagnosis || [];


  const supInfo = viewClaimInfo?.payload_json?.sup_info || {};

  const supInfoArr = Object.values(supInfo);

  const morphology = supInfoArr?.find((item) => item?.morplgy)?.morplgy;
  const morphologyDesc = viewClaimInfo?.provider_request?.medical_details?.morphologydesc;

  const labTestList = viewClaimInfo?.provider_request?.medical_details?.lab || [];


  if (!preauthDiagnosis?.length) return;
  return (
    <>
      {/* 🟩 Diagnosis Section */}
      <motion.div
        style={{ border: "2px solid #d9f8eb" }}
        className="rounded p-3 position-relative mt-3 mb-3"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
        transition={{ duration: 0.5 }}
      >
        <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
          <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
            <span className="fs-11">Diagnosis</span>
          </span>
        </div>
        <Row className="mt-3">
          {preauthDiagnosis?.map((item, idx) => {
            return (
              <Card className="p-3 mb-3" key={idx}>
                <Row className="g-3">
                  <Col
                    xs={12}
                    md={1}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <div className="category-sevie badge-subtle-success text-success">
                      {idx + 1}
                    </div>
                  </Col>
                  <Col xs={6} md={2}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">Type</span>
                      <span className="fs-10 fw-normal text-600">
                        {item?.diagonis_type}
                      </span>
                    </div>
                  </Col>
                  <Col xs={6} md={2}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">Condition Onset</span>
                      <span className="fs-10 fw-normal text-600">
                        {item?.diagonis_onsetdescrption}
                      </span>
                    </div>
                  </Col>
                  <Col xs={6} md={2}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">On Admission</span>
                      <span className="fs-10 fw-normal text-600">
                        {item?.diagonis_onadms}
                      </span>
                    </div>
                  </Col>
                  <Col xs={12} md={5}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">Code/Desc.</span>
                      <span className="fs-10 fw-normal text-600">
                        {`(${item?.diagonis_code}) - ${item?.diagonis_description || ""
                          }`}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </Row>
      </motion.div>

      {/* 🟦 Morphology Section */}
      {!!morphology?.code && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative mt-3 mb-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
              <span className="fs-11">Morphology</span>
            </span>
          </div>
          <Row>
            <Col xs={12}>
              <Card className="p-3">
                <Row className="g-3">
                  <Col xs={12} md={1}>
                    <div className="category-sevie badge-subtle-danger text-danger">
                      1
                    </div>
                  </Col>
                  <Col xs={3}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">Code</span>
                      <span className="fs-10 fw-normal text-600">
                        {morphology?.code}
                      </span>
                    </div>
                  </Col>
                  <Col xs={8}>
                    <div className="d-flex flex-column">
                      <span className="fs-10 fw-bold">Description</span>
                      <span className="fs-10 fw-normal text-600">
                        {morphologyDesc}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </motion.div>
      )}

      {/* 🧪 Lab Test Section */}
      {labTestList && labTestList.length > 0 && (
        <motion.div
          style={{ border: "2px solid #e6e6ff" }}
          className="rounded p-3 position-relative mt-3 mb-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-primary">
              <span className="fs-11">Lab Tests</span>
            </span>
          </div>
          <Row className="mt-3">
            {labTestList?.map((item, idx) => {
              return (
                <Card className="p-3 mb-3" key={`lab-${idx}`}>
                  <Row className="g-3 align-items-center">
                    <Col xs={12} md={1}>
                      <div className="category-sevie badge-subtle-primary text-primary">
                        {idx + 1}
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="d-flex flex-column">
                        <span className="fs-10 fw-bold">Code/Description</span>
                        <span className="fs-10 fw-normal text-600">
                          {`(${item?.code}) - ${item?.name || ""}`}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={2}>
                      <div className="d-flex flex-column">
                        <span className="fs-10 fw-bold">Unit</span>
                        <span className="fs-10 fw-normal text-600">
                          {item?.uom}
                        </span>
                      </div>
                    </Col>
                    <Col xs={12} md={3}>
                      <div className="d-flex flex-column">
                        <span className="fs-10 fw-bold">Quantity</span>
                        <span className="fs-10 fw-normal text-600">
                          {item?.qty}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Card>
              );
            })}
          </Row>
        </motion.div>
      )}
    </>
  );
};

export default ClaimProviderDiagnosis;

const onAdmission = [
  { code: "y", value: "Yes" },
  { code: "n", value: "No" },
  { code: "u", value: "Unknown" },
];
